import React, { useEffect, useRef } from "react";
import styles from "./Contact.module.css";

import KtcMyFooter from "./ktc_my_footer";
import KtcHeader from "./Ktcheader";

const KtcContact = () => {
  const iframeRef = useRef(null);

  // Automatically resize iframe to fit content (only works if same-domain)
  const resizeIframe = () => {
    if (iframeRef.current) {
      try {
        const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
        iframeRef.current.style.height = iframeDoc.body.scrollHeight + "px";
      } catch (err) {
        console.warn("Cannot access iframe height (cross-domain):", err);
      }
    }
  };

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.addEventListener("load", resizeIframe);
    }
    return () => iframe && iframe.removeEventListener("load", resizeIframe);
  }, []);

  return (
    <>
      <KtcHeader></KtcHeader>
      <div className={styles.container}>
        <div className={styles.mapForm}>
          {/* Map Left */}
          <div className={styles.mapBox}>
            <iframe



              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d65326024.26230059!2d45.210303!3d2.082146!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3d58421cd6a3d221%3A0x7b479f492791abfe!2sUniversity%20of%20Somalia%20(%20UNISO)!5e0!3m2!1sen!2sso!4v1759299819500!5m2!1sen!2sso"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>

          {/* Form Right */}
          <div className={styles.formBox}>
            <iframe
            
              src="/portal/register-contact_messages"
              title="Contact Form"
              style={{ width: "70%", height:"100vh", border: "none", overflow: "hidden" }}
              onScrolling="no"
            />
          </div>
        </div>
      </div>
      <KtcMyFooter></KtcMyFooter>
    </>
  );
};

export default KtcContact;